export default {
      id: "ic_author_icon-usage",
      viewBox: "0 0 26 19",
      url: "/" + "images/icons.3.109.2.svg#ic_author_icon-usage",
      toString: function () {
        return this.url;
      }
    }